import { useMemo } from 'react';
import {
  useOperationsHistory,
  useOperationStatusIcons,
  useOperationTypesIcons,
} from '@/shared/api';
import { matchesSearchQuery } from '@/shared/lib';

const useSearchHistoryResults = (normalizedQuery: string) => {
  const { operationsHistory, isOperationsHistoryLoading } =
    useOperationsHistory('all');

  const { operationsStatusIconsData, isOperationStatusIconsLoading } =
    useOperationStatusIcons();
  const { operationTypeIconsData, isOperationTypesIconsLoading } =
    useOperationTypesIcons();

  const operations = useMemo(
    () =>
      (operationsHistory?.operations ?? []).filter(operation =>
        matchesSearchQuery(normalizedQuery, [
          operation.asset.code,
          operation.asset.name,
          operation.additionalAsset?.code,
          operation.additionalAsset?.name,
        ])
      ),
    [operationsHistory, normalizedQuery]
  );

  return {
    operations,
    statusIcons: operationsStatusIconsData?.value ?? [],
    typeIcons: operationTypeIconsData?.value ?? [],
    isHistoryLoading:
      isOperationsHistoryLoading ||
      isOperationStatusIconsLoading ||
      isOperationTypesIconsLoading,
  };
};

export { useSearchHistoryResults };
